var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileperson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50056 15.8564C4.91552 15.8564 1 16.5497 1 19.326C1 22.1023 4.89068 22.8204 9.50056 22.8204C14.0856 22.8204 18 22.126 18 19.3508C18 16.5756 14.1104 15.8564 9.50056 15.8564Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50055 11.8964C12.5095 11.8964 14.9482 9.45653 14.9482 6.44763C14.9482 3.43873 12.5095 1 9.50055 1C6.49165 1 4.05179 3.43873 4.05179 6.44763C4.04163 9.44637 6.46455 11.8862 9.46216 11.8964H9.50055Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileperson);
export default __webpack_public_path__ + "static/media/profileperson.e5c0c2e149ba4b7448a02e11d4a156dd.svg";
export { ForwardRef as ReactComponent };